import {css, StyleSheet} from 'aphrodite';
import React from 'react';

import {BaseTypedValueType, TypedValue} from 'notebook/tables/typed-values/TypedValueConstants';
import ReagentChip from 'samples/plate-maps/fill-plate-modal/ReagentChip';
import {FrozenEntityChipData} from 'samples/plate-maps/plate-record/PlateRecordConstants';
import {ReagentAssignmentGroup, ReagentType, TestOrderInfoById} from 'samples/plate-maps/PlateMapConstants';
import {ChipSize} from 'ui-library/chips/Chip';

interface FillPlateTransferSourceChipProps {
  typedValue: TypedValue;
  frozenEntityChipData: {[id: string]: FrozenEntityChipData};
  reagentGroupsById: {[id: string]: ReagentAssignmentGroup};
  testOrderInfoById: TestOrderInfoById;
}

export default function FillPlateTransferSourceContainerChip({
  typedValue,
  frozenEntityChipData,
  reagentGroupsById,
  testOrderInfoById,
}: FillPlateTransferSourceChipProps): JSX.Element | null {
  if (typedValue.type === BaseTypedValueType.JSON) {
    const {reagent} = typedValue.jsonValue;
    if (reagent != null) {
      if (reagent.type === ReagentType.SOURCE_CONTAINABLE) {
        return <div className={css(styles.notApplicable)}>N/A</div>;
      } else if (reagent.type === ReagentType.WELL_CONTENT) {
        return <div className={css(styles.notApplicable)}>Preexisting content(s)</div>;
      } else if (reagentGroupsById != null && reagent.type === ReagentType.SOURCE_CONTAINER) {
        return (
          <ReagentChip
            chipSize={ChipSize.TABLE_CELL}
            frozenChipDisplayOverrides={frozenEntityChipData}
            reagent={reagent}
            reagentGroupsById={reagentGroupsById}
            testOrderInfoById={testOrderInfoById}
          />
        );
      }
    }
  }
  return null;
}

const styles = StyleSheet.create({
  notApplicable: {
    fontStyle: 'italic',
  },
});
